import aggregateDefs from '@/layouts/variables/aggregateVariableDefs';

/**
 * Gets dependent variables or rules of a given variable
 * Assumes that each variable or rule has a name.
 * @param variable to look for dependants
 * @param formulas that can have the variable as dependency.
 * @returns {Array} the list of names that have variable as dependency.
 */
const getDependencies = (variable, formulas) => {
  const dependencies = [];
  const id = Number(variable.id);
  for (let i = 0; i < formulas.length; i++) {
    if (formulas[i].goal === undefined && formulas[i].varOneIds.length > 0) {
      if (formulas[i].varOneIds.includes(id)) {
        dependencies.push(formulas[i].name);
      }
    } else {
      if (formulas[i].goal !== aggregateDefs.goal.metrical) {
        if (formulas[i].varOneId) {
          const varOneId = Number(formulas[i].varOneId);
          if (id === varOneId) {
            dependencies.push(formulas[i].name);
          }
        }
        if (formulas[i].varTwoId) {
          const varTwoId = Number(formulas[i].varTwoId);
          if (id === varTwoId) {
            dependencies.push(formulas[i].name);
          }
        }
      } else {
        if (formulas[i].variableList.includes(id)) {
          dependencies.push(formulas[i].name);
        }
      }
    }
  }

  return dependencies.filter(onlyUnique);
};

const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
};

export default {
  getDependencies
};



// WEBPACK FOOTER //
// ./src/layouts/variables/dependencies.js